module.exports = __webpack_public_path__ + "img/img14.975ac82f.png";